// Generated by Melange

import * as Buhta_cabinet__DashboardTemplate from "../../templates/DashboardTemplate.js";
import * as Buhta_cabinet__ProfileApiPage from "./ProfileApiPage.js";
import * as Buhta_cabinet__ProfileGeneralPage from "./ProfileGeneralPage.js";
import * as Buhta_cabinet__ProfileSecurityPage from "./ProfileSecurityPage.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__SidebarProfile from "../../components/molecules/Sidebar/SidebarProfile.js";
import * as JsxRuntime from "react/jsx-runtime";

function ProfilePage(Props) {
  let route = Props.route;
  let profile = Props.profile;
  let org = Props.org;
  const currentRoute = Buhta_cabinet__Route.ofUrl(Buhta_cabinet__Route.useUrl(undefined));
  const sidebar = JsxRuntime.jsx(Buhta_cabinet__SidebarProfile.make, {
    currentRoute: currentRoute,
    org: org
  });
  let tmp;
  switch (route) {
    case /* General */ 0 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__ProfileGeneralPage.make, {
        profile: profile
      });
      break;
    case /* Security */ 1 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__ProfileSecurityPage.make, {});
      break;
    case /* API */ 2 :
      tmp = JsxRuntime.jsx(Buhta_cabinet__ProfileApiPage.make, {});
      break;
  }
  return JsxRuntime.jsx(Buhta_cabinet__DashboardTemplate.make, {
    sidebar: sidebar,
    children: tmp
  });
}

const make = ProfilePage;

export {
  make,
}
/* Buhta_cabinet__DashboardTemplate Not a pure module */
